<template>
  <div>
    <div class="text-muted small">{{ notification.created_at | formatRelativeDate }}</div>
    <div>
      {{ $t('notifications.test.sent_back', { test: notification.data.test ? notification.data.test.name : '' }) }}
      <span> {{ $t('system.in') }}</span>
      <span> {{ $t('tasks.log.title') }}</span>
      "{{ notification.data.task.project.title }}"
      <div v-if="notification.data.test && notification.data.test.comment" class="text-muted text-formatted mt-1">{{ notification.data.test.comment }}</div>
      <router-link
          :to="{ name: 'Home', query: { client: notification.data.task.project.client, task_id: notification.data.task.id, type: 'doc_collection_tasks' } }"
          v-if="getClient.projectModule"
      >
        {{ $t('system.view') }} {{ $t('tasks.open_tasks') }}
      </router-link>
    </div>
  </div>
</template>

<script>
// An auditor sent a test (sample) back to the documentation collection user
export default {
  name: 'CollectionTestSentBack',
  props: {
    notification: {}
  },
  computed: {
    getClient() {
      return this.$store.state.client;
    }
  }
}
</script>
